import React, { useEffect, useState } from "react";
import {
    useTheme,
    TextField,
    IconButton,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Grid,
    Paper,
    Box,
    FormControl,
    NativeSelect,
    InputLabel,
    Card,
    CardContent,
    Typography,
    Select,
    MenuItem,
    Tooltip,
    Tab,
    Tabs,
    InputAdornment,
    Skeleton
  } from "@mui/material";
  
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FaEdit, FaTrash, FaInfoCircle } from "react-icons/fa";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import SearchIcon from '@mui/icons-material/Search';
import { ToastContainer, toast } from "react-toastify";
import baseURL from "../config";
import CryptoJS from "crypto-js";
import RecordsTable from "../Components/RecordsTable";

const Clients = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filtereduserData, setFiltereduserData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [userTabValue, setUserTabValue] = useState(0);
  const [userTransactions, setUserTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [transactionDialogOpen, setTransactionDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  

  const [userData, setuserData] = useState({
      userId: 0,
      password: "",
      email: "",
      phoneNumber: "",
      address: "",
      state: "",
      role: "",
      gender: "",
      birthdate: "",
      message: "",
      name: "",
      surname: "",
      success: true,
      loyaltyCardNumber: "",
      levelId: 0
});

const getDecryptedToken = () => {
  const encryptedToken = Cookies.get("token");
  if (!encryptedToken) return null;

  const secretKey = '19092002'; 
  const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
  const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

  return decryptedToken || null;
};


const token = getDecryptedToken();

//api calls
const fetchClients = async () => {
  try {
    const response = await axios.get(
      baseURL+"/api/User/GetUsers",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      const users = response.data.users;
      setFiltereduserData(users);
    } else {
     toast.error("Failed to fetch users: Success flag is false");
    }
  } catch (error) {
    toast.error("Error fetching client data:", error);
  }
};

const fetchTransactionsWithUserId = async (userId) => {

  setUserTransactions([]);
  try{
    const response = await axios.get(
      baseURL+"/api/Transaction/GetTransactionByUserId",
      {
        headers: {
          Authorization : `Bearer ${token}`,
        },
        params: {
          id: userId,
        }
      }
    );
    if(response.data.success){
      
     
      const transaction = response.data.transactions
      setUserTransactions(transaction);
    }
    else {
      
    }
  }catch (error) {

  }
}

useEffect(() => {
   const fetchClients = async () => {
    try {
      const response = await axios.get(
        baseURL+"/api/User/GetUsers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        const users = response.data.users;
        setIsLoading(false);
        setFiltereduserData(users);
      
      } else {
        toast.error("Failed to fetch users: Success flag is false");
      }
    } catch (error) {
      toast.error("Error fetching client data:", error);
    }
  };

  fetchClients();
}, []);
//this method fetches a user based on id
const fetchUser = async (userId) => {
    try {
      const response = await axios.get(
        baseURL+`/api/User/GetUser`, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: userId, 
          },
        }
      );
  
      if (response.data.success) {
        const user = response.data.user;
        setuserData(user); 
     
      } else {
        toast.error("Failed to fetch user: Success flag is false");
      }
    } catch (err) {
      toast.error("Error fetching user:", err);
    }
  };

  const handleSave = async () => {
    try {
      const response = await axios.post(
        baseURL+`/api/User/UpdateUser`, 
        userData, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      
      if (response.status == 200) {
       await fetchClients(); 
       

        setDialogOpen(false);
       
        toast.success("Klienti u perditesua me sukses!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Failed to update user: Success flag is false");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Failed to update user.");
    }
  };
  
  

  const handleEdit = (event) => {
    setuserData({
      ...userData,
      [event.target.name]: event.target.value,
    });
    setUserTransactions({
      ...userTransactions,
      [event.target.name]: event.target.value
    })
  
  };

  

  const handleInfo = (id) => {
    fetchUser(id);
    fetchTransactionsWithUserId(id);
    setSelectedUser(id);
    setDialogOpen(true);
    
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onDeleteClick = (id) => {

  }

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  }
  const filteredData = filtereduserData.filter((user) => {
    const searchQueryLower = searchQuery.toLowerCase();
    return (
      (user.name && user.name.toLowerCase().includes(searchQueryLower)) ||
      (user.surname && user.surname.toLowerCase().includes(searchQueryLower)) ||
      (user.email && user.email.toLowerCase().includes(searchQueryLower)) ||
      (user.phoneNumber && user.phoneNumber.toLowerCase().includes(searchQueryLower)) ||
      (user.userId && user.userId.toString().includes(searchQueryLower))
    );
  });
  
  const desktopColumns = [
    {
      field: "userId",
      headerName: "ID",
      headerClassName: 'super-app-theme--header',
      flex: 0.35,
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    { field: "surname", headerName: "Surname", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "email", headerName: "Email",headerClassName: 'super-app-theme--header', flex: 1.4 },
    { field: "phoneNumber", headerName: "Phone", headerClassName: 'super-app-theme--header', flex: 1 },
    {
      field: "isActive",
      headerName: "Status",
      headerClassName: 'super-app-theme--header',
      flex: 0.8,
      renderCell: (params) => (
        <span className={`table-pill ${params.value ? "success" : "danger"}`}>
          {params.value ? "Active" : "Inactive"}
        </span>
      ),
    },
        {
            field: "Actions",
            headerName: "",
            flex: 0.35,
            sortable: false,
            filterable: false,
            headerClassName: 'super-app-theme--header',
      
            renderCell: (params) => {
              return (
                <>
                  <IconButton
                    onClick={() => handleInfo(params.row.userId)}
                    className="table-action-button"
                    aria-label="Edit client"
                  >
                    <DriveFileRenameOutlineIcon />
                  </IconButton>    
                </>
              );
            },
          },
        ];

        const mobileColumns = [
          {
            field: "name",
            headerName: "Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
          },
          { field: "surname", headerName: "Surname", headerClassName: "super-app-theme--header", flex: 1 },
          {
            field: "Actions",
            headerName: "",
            flex: 0.5,
            sortable: false,
            filterable: false,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => (
              <IconButton onClick={() => handleInfo(params.row.userId)} className="table-action-button" aria-label="Edit client">
                <DriveFileRenameOutlineIcon />
              </IconButton>
            ),
          },
        ];

        const columns = isNonMobile ? desktopColumns : mobileColumns;

  return (
    <Box m="10px">
      <Header title="Klientet" subtitle="Edito klientet" />
      <ToastContainer />

      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      <Link to="/clientForm" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.primary[700], marginLeft: "20px", marginTop: "8px" }}
        >
          Shto Klient
        </Button>
      </Link>
      </Box>

      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"},
          "& .MuiButtonBase-root": {color: colors.redAccent[500]}

        }}
      >
        <div style={{ width: '100%' }}>
        {isLoading ? (
         
          <Skeleton
            variant="rectangular"
            width="100%"
            height={500}
            animation="wave"
          />
        ) : (
          
          <RecordsTable
            columns={columns}
            onRowDoubleClick={(params) => handleInfo(params.row.userId)}
            rows={filteredData}
            getRowId={(row) => row.userId}
            emptyMessage="No clients match your search."
          />
        )}
        </div>
        {/* This dialog opens the info about a selected client */}
              <Dialog className="client-editor-dialog" open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500] }}
          >
            
              <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {userTabValue}
                  onChange ={(e, value) => setUserTabValue(value)}  
                >
                  <Tab
                    label="Info per klientin"
                    sx={{
                      color: "red",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  <Tab
                    label="Transaksionet"
                    sx={{
                      color: "red",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  </Tabs>
              </div>
                {userTabValue === 0 && (
                  <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >
                    <TextField
                      label="Name"
                      name="name"
                      value={userData.name ? userData.name : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Surname"
                      name="surname"
                      value={userData.surname ? userData.surname : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Gjinia"
                      name="gender"
                      value={userData.gender}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Phone Number"
                      name="phoneNumber"
                      value={
                        userData.phoneNumber ? userData.phoneNumber : ""
                      }
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                 
                    <TextField
                      label="Email"
                      name="email"
                      value={userData.email ? userData.email : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "30px",
                      }}
                       
                    />
                    <TextField
                      label="Customer Group Id"
                      name="customerGroupId"
                      value={userData.customerGroupId ? userData.customerGroupId : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                    <TextField
                      label="Role"
                      name="role"
                      value={userData.role ? userData.role : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                    <TextField
                      label="Birthdate"
                      name="birthdate"
                      value={userData.birthdate ? userData.birthdate : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                    <TextField
                      label="State"
                      name="state"
                      value={userData.state ? userData.state : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                    />
                    <TextField
                      label="Level"
                      name="levelId"
                      value={userData.levelId ? userData.levelId : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      disabled
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                    />
                  </div>
                )}
                                            {userTabValue === 1 && (
                                              <div
                                                style={{
                                                  margin: "10px",
                                                  textAlign: "center",
                                                  display: isNonMobile ? undefined : "flex",
                                                  flexDirection: isNonMobile ? "row" : "column",
                                                }}
                                              >
                                                {userTransactions.length > 0 ? (
                                                  <div style={{ width: "100%", maxHeight: "500px", overflowY: "auto", }}>
                                                    <table
                                                      style={{
                                                        width: "100%",
                                                        borderCollapse: "collapse",
                                                        textAlign: "left",
                                                        backgroundColor: colors.primary[600],
                                                      }}
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <th style={{ borderBottom: "1px solid #fff", padding: "10px" }}>Store</th>
                                                          <th style={{ borderBottom: "1px solid #fff", padding: "10px" }}>Amount</th>
                                                          <th style={{ borderBottom: "1px solid #fff", padding: "10px" }}>Bonus Points</th>
                                                          <th style={{ borderBottom: "1px solid #fff", padding: "10px" }}>Date</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                          {
                                                            
                                                            userTransactions
                                                            .filter((transaction) => transaction.transType === 0)
                                                            .map((transaction, index) => (
                                                            console.log(userTransactions),

                                                            <tr 
                                                              key={index} 
                                                              onClick={() => {
                                                                setSelectedTransaction(transaction);
                                                                setTransactionDialogOpen(true);
                                                              }}
                                                              style={{ cursor: "pointer", backgroundColor: colors.primary[500]}}
                                                              >
                                                              <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                {transaction.store || "N/A"}
                                                              </td>
                                                              <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                {transaction.transactionAmount ? transaction.transactionAmount : 0 + " €" || "N/A"}
                                                              </td>
                                                              <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                {transaction.bonusPoints || "N/A"}
                                                              </td>
                                                              <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                {new Date(transaction.createDate).toLocaleDateString() || "N/A"}
                                                              </td>
                                                             
                                                            </tr>
                                                          ))}
                                                          <tr>
                                                                  <td
                                                                    colSpan="4"
                                                                    style={{
                                                                      textAlign: "right",
                                                                      fontWeight: "bold",
                                                                      padding: "10px",
                                                                      borderTop: "2px solid #ddd",
                                                                    }}
                                                                  >
                                                                    Total Transactions Amount:{" "}
                                                                    {userTransactions
                                                                      .reduce((sum, transaction) => sum + parseFloat(transaction.transactionAmount || 0), 0)
                                                                      .toFixed(2)}{" "}
                                                                    €
                                                                  </td>
                                                           </tr>
                                                        </tbody>

                                                    </table>
                                                  </div>
                                                ) : (
                                                  <Typography
                                                    variant="h6"
                                                    style={{
                                                      marginTop: "20px",
                                                      color: colors.primary[900],
                                                    }}
                                                  >
                                                    Nuk ka transaksione për këtë përdorues.
                                                  </Typography>
                                                )}
                                              </div>
                                            )}
                                                      <Dialog
                                                        open={transactionDialogOpen}
                                                        onClose={() => setTransactionDialogOpen(false)}
                                                        maxWidth="sm"
                                                        fullWidth
                                                      >
                                                        <DialogTitle>Transactions Details</DialogTitle>
                                                        <DialogContent>
                                                          {selectedTransaction ? (
                                                            <div style={{ margin: "20px" }}>
                                                              <Typography variant="body1">
                                                                <strong>Transaction Id:</strong> {selectedTransaction.id || "N/A"}
                                                              </Typography>
                                                              <Typography variant="body1">
                                                                <strong>Store:</strong> {selectedTransaction.store || "N/A"}
                                                              </Typography>
                                                              <Typography variant="body1">
                                                                <strong>Amount:</strong> {selectedTransaction.transactionAmount + " €" || "N/A"}
                                                              </Typography>
                                                              <Typography variant="body1">
                                                                <strong>Bonus Points:</strong> {selectedTransaction.bonusPoints || "N/A"}
                                                              </Typography>
                                                              <Typography variant="body1">
                                                                <strong>Date:</strong> {new Date(selectedTransaction.createDate).toLocaleString() || "N/A"}
                                                              </Typography>
                                                              <Typography variant="body1" style={{ marginTop: "20px" }}>
                                                                <strong>Transaction Lines:</strong>
                                                              </Typography>
                                                              {selectedTransaction.transactionLines && selectedTransaction.transactionLines.length > 0 ? (
                                                                <div style={{ marginTop: "10px", maxHeight: "300px", overflowY: "auto" }}>
                                                                  <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}>
                                                                    <thead>
                                                                      <tr>
                                                                        <th style={{ borderBottom: "1px solid #ddd", padding: "10px" }}>Product ID</th>
                                                                        <th style={{ borderBottom: "1px solid #ddd", padding: "10px" }}>Product Name</th>
                                                                        <th style={{ borderBottom: "1px solid #ddd", padding: "10px" }}>Unit Price</th>
                                                                        <th style={{ borderBottom: "1px solid #ddd", padding: "10px" }}>Quantity</th>
                                                                        <th style={{ borderBottom: "1px solid #ddd", padding: "10px" }}>Unit of Measure</th>
                                                                        
                                                                      </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                      {selectedTransaction.transactionLines.map((line, index) => (
                                                                        <tr key={index}>
                                                                          <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                            {line.productId || "N/A"}
                                                                          </td>
                                                                          <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                            {line.productName|| "N/A"}
                                                                          </td>
                                                                          <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                            {line.unitPrice ? `${line.unitPrice} €` : "N/A"}
                                                                          </td>
                                                                          <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                            {line.quantity|| "N/A"}
                                                                          </td>
                                                                          <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                                                            {line.productUnitOfMeasure || "N/A"}
                                                                          </td>
                                                                        </tr>
                                                                      ))}
                                                                    </tbody>
                                                                  </table>
                                                                </div>
                                                              ) : (
                                                                <Typography variant="body1" style={{ marginTop: "10px", color: "#888" }}>
                                                                  No transaction lines available.
                                                                </Typography>
                                                              )}

                                                              
                                                              
                                                            </div>
                                                          ) : (
                                                            <Typography variant="body1">No transaction selected.</Typography>
                                                          )}
                                                        </DialogContent>
                                                        <DialogActions>
                                                          <Button onClick={() => setTransactionDialogOpen(false)} sx={{ backgroundColor: "white" }}>
                                                            Close
                                                          </Button>
                                                        </DialogActions>
                                                      </Dialog>

              
                  <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{ backgroundColor: "white" }}
                >
                  Save
                </Button>
              </DialogActions>
              </DialogContent>
              </Dialog>
      </Box>
    </Box>
  );
};

export default Clients;
